module.exports = __webpack_public_path__ + "static/consult-banner-53a38bd671e3ccceb225c538a90fe686.png";